import { Space } from 'antd';
import styled from 'styled-components';
import { type OptionSettingDetailsFragment } from '../../../../../api/fragments/OptionSettingDetails';
import { OptionType } from '../../../../../api/types';
import CheckboxGroupField from '../../../../../components/fields/CheckboxGroupField';
import { useThemeComponents } from '../../../../../themes';
import useCompanyFormats from '../../../../../utilities/useCompanyFormats';
import useTranslatedString from '../../../../../utilities/useTranslatedString';

const StyledCheckboxGroupField = styled(CheckboxGroupField)`
    & label {
        font-size: inherit;
        width: 100%;
        display: flex;
        align-items: baseline;

        & > span.ant-checkbox + span {
            width: 100%;
        }
    }
`;

const LabelContainer = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: inherit;
`;

const Description = styled.div`
    margin-left: 1rem;
    font-weight: 900;
    text-align: right;
    white-space: nowrap;
`;

export type OptionCheckboxFieldProps = {
    name: string;
    optionSetting: OptionSettingDetailsFragment;
    companyId: string;
};

const OptionCheckboxField = ({ name, optionSetting, companyId }: OptionCheckboxFieldProps) => {
    const translatedString = useTranslatedString();
    const companyFormats = useCompanyFormats(companyId);

    const { Checkbox } = useThemeComponents();

    if (optionSetting.__typename !== 'MultiSelectOptionSettings') {
        return null;
    }

    return (
        <StyledCheckboxGroupField name={name} style={{ width: '100%' }}>
            <Space direction="vertical" size={16} style={{ display: 'flex', width: '100%' }}>
                {optionSetting.options.map(option => (
                    <Checkbox key={option.id} value={option.id}>
                        <LabelContainer>
                            {translatedString(option.label)}
                            <Description>
                                {option.type === OptionType.Price
                                    ? companyFormats.formatAmountWithCurrency(option.valuePrice)
                                    : translatedString(option.valueText)}
                            </Description>
                        </LabelContainer>
                    </Checkbox>
                ))}
            </Space>
        </StyledCheckboxGroupField>
    );
};

export default OptionCheckboxField;
